import classnames from 'classnames';
import ReactSelect, { components } from 'react-select';
import s from './index.module.scss';

const ChevronDown = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 7.5L10 12.5L15 7.5" stroke="#1A2833" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ChevronDown />
  </components.DropdownIndicator>
);

export const Select = ({ label, name, error, className, ...props }) => {
  return (
    <div className={classnames(s.wrapper, className)}>
      {label && (
        <label className="f-small-accent" htmlFor={name}>
          {label}
        </label>
      )}
      <ReactSelect
        inputId={name}
        name={name}
        classNamePrefix="compliance_select"
        className={classnames(s.select, error && s.select_error)}
        components={{ DropdownIndicator }}
        {...props}
      />
      {error && <div className={s.error_message}>{error}</div>}
    </div>
  );
};